module.exports = __webpack_public_path__ + "static/road_image-a03503aa4901b3d9aa9db2aa54ca44c5.jpg";